module.exports = __webpack_public_path__ + "static/media/vegitables_16.07051b28.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_16.csv
// module id = 598
// module chunks = 0